/**
 * i18n Configuration
 * Bulgarian and English internationalization setup
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import bgTranslations from './locales/bg.json';
import enTranslations from './locales/en.json';

// Language resources
const resources = {
  bg: {
    translation: bgTranslations,
  },
  en: {
    translation: enTranslations,
  },
};

// Initialize i18next
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'bg', // Default language is Bulgarian
    fallbackLng: 'en', // Fallback to English if translation not found
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
